<template>
  <div>
    <v-row dense>
      <v-col cols="12" sm="6" md="6">
        <r-task-action :model.sync="value.action"/>
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <r-task-time-type :model.sync="value.timeType"/>
      </v-col>
    </v-row>
    <v-row dense class="mb-4" v-if="timeTypeCode === 0">
      <v-col cols="12" sm="6" md="6">
        <v-text-field v-model.number="value.duration" label="Duration (seconds):" hide-details/>
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <r-ad-placement-dropdown :model.sync="value.adPlacement" title="Ad Placement" hide-details/>
      </v-col>
    </v-row>
    <v-row dense v-if="timeTypeCode === 1">
      <v-col cols="12" sm="6" md="6">
        <v-text-field v-model.number="value.interval" label="Interval (seconds):" hide-details/>
      </v-col>
    </v-row>
    <v-row dense class="mb-4" v-if="timeTypeCode === 1">
      <v-col cols="12" sm="6" md="6">
        <v-text-field v-model.number="value.startOffset" label="Start Offest (seconds):" hide-details/>
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-text-field v-model.number="value.endOffset" label="End Offset (seconds):" hide-details/>
      </v-col>
    </v-row>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header v-slot="{ open }">
          <v-row no-gutters>
            <span style="margin-top: 5px">Prices</span>
            <v-spacer/>
            <v-fade-transition>
              <span style="display: inline-flex" v-if="open">
                  <v-divider class="mx-1" vertical/>
              </span>
            </v-fade-transition>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-divider/>
          <r-currency-table :items="value.price" title="Price"/>
          <!--                    <v-divider style="border-color: rgba(0,0,0,0.4)" class="mb-4"/>-->
          <v-divider class="mb-4"/>
          <r-currency-table :items="value.rush" title="Rush"/>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <r-reward-panel :model.sync="model.reward" title="Rewards"/>
    </v-expansion-panels>
  </div>
</template>

<script>
import VueTypes from "vue-types";
import {TaskModel} from "@/modules/redactor/models/worker/tasks/TaskModel";

import RTaskAction from "@/modules/redactor/views/worker/r-task-action";
import RTaskTimeType from "@/modules/redactor/views/worker/r-task-time-type";
import RRewardPanel from "@/modules/redactor/views/reward/r-reward-panel.vue";
import RCurrencyTable from "@/modules/redactor/views/currency/r-currency-table";
import RAdPlacementDropdown from "@/modules/redactor/views/ad-settings/placement/r-ad-placement-dropdown.vue";

export default {
  name: "r-task-config",
  components: {RAdPlacementDropdown, RTaskAction, RTaskTimeType, RCurrencyTable, RRewardPanel},
  props: {
    model: VueTypes.instanceOf(TaskModel)
  },
  computed: {
    timeTypeCode() {
      return this.model.timeType ? this.model.timeType.id : 0
    },
    value() {
      if (this.model) {
        return this.model;
      } else {
        let value = new TaskModel();
        this.$emit("update:model", value);
        return value;
      }
    }
  }
}
</script>
